<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-mgy">
    <header class="tpl-mgy__band tpl-mgy__band--top">
      <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-mgy__logo" />
    </header>

    <main class="tpl-mgy__main">
      <h1 v-if="quiz.title" class="tpl-mgy__hero-title">{{ quiz.title }}</h1>

      <div class="tpl-mgy__stepper" aria-hidden="true">
        <template v-for="n in Math.max(progress.total, 1)" :key="n">
          <span
            class="tpl-mgy__step"
            :class="{ 'tpl-mgy__step--active': isGate || n <= progress.current }"
          >{{ n }}</span>
          <span v-if="n < Math.max(progress.total, 1)" class="tpl-mgy__step-line"></span>
        </template>
      </div>

      <slot />
    </main>

    <footer class="tpl-mgy__band tpl-mgy__footer">
      <p class="tpl-mgy__footer-links">
        <a v-if="quiz.privacy_url" :href="quiz.privacy_url" target="_blank">
          {{ quiz.privacy_text || 'Privacy Policy' }}
        </a>
      </p>
      <p v-if="quiz.legal_name" class="tpl-mgy__footer-legal">
        {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
      </p>
      <p v-if="quiz.disclaimer" class="tpl-mgy__footer-disclaimer">{{ quiz.disclaimer }}</p>
    </footer>
  </div>
</template>
